export function useForm() {

  const validateGroup = async (validationGroup : Array<Element>, scrollOffset = 0) => {
    let result = true;
    let firstInvalidField;

    for (const i in validationGroup) {
      result &= await validationGroup[i].validate();

      if (!result && !firstInvalidField) {
        firstInvalidField = validationGroup[i];
      }
    }

    if (firstInvalidField && scrollOffset != null) {
      firstInvalidField.scrollTo(scrollOffset);
    }

    return result;
  }

  const resetForm = (elements : Array<Element>, soft: Boolean) => {
    for (const i in elements) {
      if (soft) {
        elements[i].softReset();
      }
      else {
        elements[i].reset();
      }
    }
  } 

  return {
    validateGroup,
    resetForm
  }
}